// Testi accorciati al limite di lunghezza dei contratti (unità UTF-16, come `maxLength` e lo schema zod) senza
// spezzare un carattere visibile: il server rifiuta la metà di un'emoji tagliata (decisione del 1° ottobre 2026).

/** Il testo, se supera `max`, fino all'ultimo carattere visibile intero che ci sta. */
export function truncateText(value: string, max: number): string {
  if (value.length <= max) return value;
  // `Intl.Segmenter` manca in Firefox prima della 125, che il target di Vite comprende: lì si evita almeno di
  // spezzare una coppia surrogata, cioè un'emoji semplice. Si legge a ogni chiamata, che è rara.
  const Segmenter = (Intl as { Segmenter?: typeof Intl.Segmenter }).Segmenter;
  if (typeof Segmenter !== "function") {
    const last = value.charCodeAt(max - 1);
    return value.slice(0, last >= 0xd800 && last <= 0xdbff ? max - 1 : max);
  }
  let end = 0;
  for (const { index, segment } of new Segmenter(undefined, { granularity: "grapheme" }).segment(value)) {
    if (index + segment.length > max) break;
    end = index + segment.length;
  }
  return value.slice(0, end);
}
